import { useState, useEffect, useRef, useCallback } from "react";
import { FaLinkedin, FaFacebookF, FaPhoneAlt, FaHandshake, FaPeopleArrows, FaHandsHelping, FaUsers, FaUserFriends } from "react-icons/fa";
import { FaXTwitter, FaEnvelope } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/inovact.png";
import logo1 from "../assets/pmi.png";
import "./Navigation.css";

const Navigation = () => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [formationsOpen, setFormationsOpen] = useState(false);
  const [mobileFormationsOpen, setMobileFormationsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleNavbar = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  // Fermer le dropdown si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFormationsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const smoothScroll = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const offset = 100;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    if (mobileDrawerOpen) {
      setMobileDrawerOpen(false);
    }
  };

  // Fonction pour naviguer vers la section "qui-est-ce-pour"
  const navigateToDevenirFormateur = () => {
    if (location.pathname === "/") {
      const element = document.getElementById("qui-est-ce-pour");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });

        if (window.location.hash) {
          window.history.replaceState(null, "", window.location.pathname);
        }
      }
    } else {
      navigate("/");

      setTimeout(() => {
        const element = document.getElementById("qui-est-ce-pour");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  // // Fonction pour déterminer si un lien est actif
  // const isLinkActive = (item) => {
  //   if (!item.isAnchor) {
  //     return location.pathname === item.href;
  //   }

  //   if (location.pathname === "/" && item.isAnchor) {
  //     return activeSection === item.href.substring(1);
  //   }

  //   return false;
  // };

  // Fonction pour déterminer si un lien est actif
  const isLinkActive = (item) => {
    // Pour les ancres (liens internes)
    if (item.isAnchor) {
      if (location.pathname === "/" && item.isAnchor) {
        return activeSection === item.href.substring(1);
      }
      return false;
    }

    // Vérification exacte du chemin
    if (location.pathname === item.href) {
      return true;
    }

    // Cas spécial : l'onglet "Entreprises" reste actif pour toutes ses sous-pages
    if (item.label === "Entreprises" && location.pathname.startsWith("/entreprises")) {
      return true;
    }

    // Cas spécial : l'onglet "Académie" reste actif pour toutes ses sous-pages
    if (item.label === "Académie" && location.pathname.startsWith("/formations")) {
      return true;
    }

    // Cas spécial : l'onglet "Pourquoi nous ?"
    if (item.label === "Pourquoi nous ?" && location.pathname === "/pourquoi-nous") {
      return true;
    }

    // Cas spécial : l'onglet "Blog"
    if (item.label === "Blog" && location.pathname.startsWith("/blog")) {
      return true;
    }

    return false;
  };

  // Fonction debounce pour optimiser les événements de scroll
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Navigation items avec IDs correspondants aux sections
  const navItemsWithIds = [
    {
      label: "Accueil",
      href: "/",
      section: 1,
      isAnchor: false
    },
    {
      label: "Entreprise",
      href: "/entreprises",
      section: 3,
      isAnchor: false
    },
    {
      label: "Académie",
      href: "/formations",
      section: 2,
      isAnchor: false // Changé de true à false car c'est maintenant une page
    },
    {
      label: "Pourquoi-nous ?",
      href: "/pourquoi-nous",
      section: 4,
      isAnchor: false // Changé de true à false car c'est maintenant une page
    },
    // {
    //   label: "Consulting",
    //   href: "/consulting",
    //   section: 4,
    //   isAnchor: false
    // },
    {
      label: "Blog",
      href: "/blog",
      section: 5,
      isAnchor: false
    },
    {
      label: "Contact",
      href: "/contactez-nous",
      section: 8,
      isAnchor: false,
    },
    // {
    //   label: "eTrainApp",
    //   href: "https://etrainapp.ivtapp.com",
    //   section: 6,
    //   isExternal: true,
    //   isAnchor: false
    // },
    // {
    //   label: "Support",
    //   href: "/a-propos-de-nous",
    //   section: 7,
    //   isAnchor: false
    // },

  ];

  // Fonction pour détecter la section active
  const detectActiveSection = useCallback(() => {
    const sections = navItemsWithIds
      .filter(item => item.isAnchor)
      .map(item => item.href.substring(1))
      .filter(id => id && id !== "#");

    let currentSection = "";
    const scrollPosition = window.scrollY + 150;

    // Trouver la section la plus proche du haut de l'écran
    let closestSection = "";
    let smallestDistance = Infinity;

    for (const section of sections) {
      const element = document.getElementById(section);
      if (element) {
        const { offsetTop, offsetHeight } = element;

        // Calculer la distance entre le haut de la section et la position de scroll
        const distance = Math.abs(offsetTop - scrollPosition);

        // Vérifier si on est dans cette section
        if (scrollPosition >= offsetTop - 100 && scrollPosition < offsetTop + offsetHeight - 100) {
          currentSection = section;
          break;
        }

        // Garder trace de la section la plus proche
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestSection = section;
        }
      }
    }

    // Si aucune section n'est trouvée comme "active", utiliser la plus proche
    if (!currentSection && closestSection && scrollPosition > 200) {
      currentSection = closestSection;
    }

    // Si on est tout en haut, réinitialiser
    if (scrollPosition < 200) {
      currentSection = "";
    }

    return currentSection;
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      const handleScroll = () => {
        const newActiveSection = detectActiveSection();
        if (newActiveSection !== activeSection) {
          setActiveSection(newActiveSection);
        }
      };

      // Version debounced pour optimiser les performances
      const debouncedScroll = debounce(handleScroll, 50);

      // Détection initiale
      handleScroll();

      window.addEventListener('scroll', debouncedScroll);
      return () => {
        window.removeEventListener('scroll', debouncedScroll);
      };
    } else {
      // Si on n'est pas sur la page d'accueil, réinitialiser
      setActiveSection("");
    }
  }, [location.pathname, activeSection, detectActiveSection]);

  return (
    <>
      {/* Barre d'informations supérieure */}
      <div className="top-info-bar">
        <div className="top-info-container">
          <div className="contact-info">
            <div className="contact-item">
              <a
              href="https://inovact.com"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
            >
              <img className="top-logo" src={logo} alt="Logo Inovact" />
            </a>
            </div>
            {/* <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <a href="mailto:info@inovact.com" className="contact-text email-link">
                info@inovact.com
              </a>
            </div> */}
          </div>

          {/* Logos côte à côte dans la barre supérieure */}
          <div className="top-logos-container">
            {/* <a
              href="https://inovact.com"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
            >
              <img className="top-logo" src={logo} alt="Logo Inovact" />
            </a> */}
            {/* <a
              href="https://inovact.com"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
            >
              <img className="top-logo" src={logo1} alt="Logo PMI" />
            </a> */}
          </div>

          {/* Bouton Parrainer un ami à droite */}
          <div className="top-right-section">
            {/* <button className="top-btn-parrainer" 
                    onClick={()=> navigate('https://etrainapp.ivtapp.com/Devenir-partenaire')}
            >
              Partenariat
            </button> */}
            <div className="contact-item">
              <FaHandshake className="contact-icon" />
              <a href="https://etrainapp.ivtapp.com/Devenir-partenaire" target="_blank" rel="noopener noreferrer" className="contact-text email-link">
                Devenir partenaire
              </a>
            </div>
            <a
              href="https://etrainapp.ivtapp.com"
              target="_blank"
              rel="noopener noreferrer"
              className="top-btn-parrainer"
            >
              eTrainApp
            </a>
            <div className="social-links-top">
              {/* <span className="follow-us">Suivez-nous:</span> */}
              <a
                href="https://www.facebook.com/inovact"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-top"
                aria-label="Facebook d'Inovact"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.linkedin.com/company/inovact"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-top"
                aria-label="LinkedIn d'Inovact"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://x.com/Inovact_Sarl"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-top"
                aria-label="Twitter (X) d'Inovact"
              >
                <FaXTwitter />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation principale */}
      <nav className="sticky-navbar">
        <div className="navbar-container">
          <div className="navbar-content">
            {/* Conteneur mobile pour les deux logos côte à côte - visible uniquement sur mobile */}
            <div className="mobile-logos-container mobile-only">
              <a
                href="https://inovact.com"
                target="_blank"
                rel="noopener noreferrer"
                className="logo-link"
              >
                <img className="logo-img mobile-logo" src={logo} alt="Logo Inovact" />
              </a>

            </div>

            {/* Navigation desktop */}
            <ul className="desktop-nav">
              {navItemsWithIds.map((item, index) => {

                {/* // Pour les liens externes
                if (item.isExternal) {
                  return (
                    <li key={index}>
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nav-link"
                      >
                        {item.label}
                      </a>
                    </li>
                  );
                } */}

                // Suppression de la condition spéciale pour "Formations"
                if (!item.isAnchor) {
                  return (
                    <li key={index}>
                      <Link
                        to={item.href}
                        className={`nav-link ${isLinkActive(item) ? "active" : ""}`}
                        onClick={() => setMobileDrawerOpen(false)}
                      >
                        {item.label}
                      </Link>
                    </li>
                  );
                }

                return (
                  <li key={index}>
                    <a
                      href={item.href}
                      onClick={(e) => smoothScroll(e, item.href.substring(1))}
                      className={`nav-link ${isLinkActive(item) ? "active" : ""}`}
                    >
                      {item.label}
                    </a>
                  </li>
                );
              })}
            </ul>

            {/* Section droite - menu mobile uniquement */}
            <div className="right-section">
              {/* Bouton menu mobile */}
              <button
                className="mobile-menu-button"
                onClick={toggleNavbar}
                aria-label="Toggle menu"
              >
                <div className="three-dots-vertical">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* ESPACEUR POUR COMPENSER LA NAVBAR FIXE */}
      <div className="navbar-spacer"></div>

      {/* Menu mobile */}
      {mobileDrawerOpen && (
        <>
          <div
            className="mobile-overlay"
            onClick={() => setMobileDrawerOpen(false)}
          />
          <div className="mobile-drawer">
            <ul className="mobile-nav-list">
              {navItemsWithIds.map((item, index) => {
                // Suppression de la condition spéciale pour "Formations" dans le menu mobile
                if (!item.isAnchor) {
                  return (
                    <li key={index} className="mobile-nav-item">
                      <Link
                        to={item.href}
                        className={`mobile-nav-link ${isLinkActive(item) ? "active" : ""}`}
                        onClick={() => setMobileDrawerOpen(false)}
                      >
                        {item.label}
                      </Link>
                    </li>
                  );
                }

                return (
                  <li key={index} className="mobile-nav-item">
                    <a
                      href={item.href}
                      onClick={(e) => smoothScroll(e, item.href.substring(1))}
                      className={`mobile-nav-link ${isLinkActive(item) ? "active" : ""}`}
                    >
                      {item.label}
                    </a>
                  </li>
                );
              })}

              {/* Boutons à la fin du menu mobile */}
              <div className="mobile-buttons">
                <button className="top-btn-parrainer mobile-btn">
                  Prendre RDV
                </button>
              </div>
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default Navigation;